import { useReducer, useEffect } from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'

// styling
import './App.css'

// views
import Home from './views/Home'
import HereNow from './views/HereNow'
import OneLastThing from './views/OneLastThing'
import Sorry from './views/Sorry'
import Done from './views/Done'
import NoBooking from './views/NoBooking'
import EnterDetails from './views/EnterDetails'

// store
import { Context, initialState, reducer } from './store'
import types from './store/types'

// API
import { getToken, fetchClub } from './API'

import { init } from 'application-translator/dist/translate/translate.react.js';
import { useCookies } from "react-cookie";
import acceptLanguageParser from "accept-language-parser";

function App() {
  const [globalState, dispatch] = useReducer(reducer, initialState)

  const clubId = window.location.pathname.split('/')[2]

  // fetch required initial data to load the app
  const fetchInitialData = async () => {
    if (!clubId) return

    dispatch({ type: types.SET_CLUB_LOADING, payload: true })

    // get club data
    const clubData = await fetchClub(clubId)

    dispatch({ type: types.SET_CLUB_DATA, payload: clubData })
    dispatch({ type: types.SET_CLUB_LOADING, payload: false })

    // when club is not found, redirect to home page to show catch-all message
    if (!clubData.id && window.location.pathname !== `/links/${clubId}`) {
      window.location.replace(`/links/${clubId}`)
    }

    // get auth token for main API
    const response = await getToken()
    const { token } = response || {}

    dispatch({ type: types.UPDATE_TOKEN, payload: token })
  }
  useEffect(() => {
    fetchInitialData()
  }, [])

  const [cookies, setCookie] = useCookies(["locale"]);

  useEffect(() => {
  
    const getLocale = () => {
      const acceptLanguageHeader = navigator.languages.join(", ");
      const userLanguages = acceptLanguageParser.parse(acceptLanguageHeader);
    
      // If the user has a preferred locale in a cookie, use it
      const preferredLocale = cookies.locale;

      return preferredLocale ? preferredLocale : userLanguages[0] ? userLanguages[0].code : 'en';
    };

    const initTranslations = async () => {
      const locale = getLocale();
      //const locale = 'ja';

      //dont do anything if locale is english
      if(locale === 'en') return;

      await init(`links/translations/${locale}.json`, () => {return locale});
     
    }

    initTranslations();
  });

  return (
    <Context.Provider value={{ globalState, dispatch }}>
      <div className="App">
        <Router>
          <Switch>
            <Route path="/links/:clubId/here-now">
              <HereNow />
            </Route>
            <Route path="/links/:clubId/final">
              <OneLastThing />
            </Route>
            <Route path="/links/:clubId/sorry">
              <Sorry />
            </Route>
            <Route path="/links/:clubId/no-booking">
              <NoBooking />
            </Route>
            <Route path="/links/:clubId/enter-details">
              <EnterDetails />
            </Route>
            <Route path="/links/:clubId/success">
              <Done />
            </Route>
            <Route path="/links/:clubId">
              <Home />
            </Route>
            <Route path="/links">
              <Home />
            </Route>
          </Switch>
        </Router>
      </div>
    </Context.Provider>
  )
}

export default App
